import React from 'react';

// import CookieContext from '../../../hochschul-frontpage/src/customizations/components/theme/CookieProvider';
import { useDonation } from 'volto-stiftung-hochschulmedizin/customizations/volto/components/theme/Donation/DonationContext';

import heartIcon from './heart-fill.svg';

const View = ({ data, isEditMode, className }) => {
  const { toggleDonationForm } = useDonation();

  return (
    <div className="page-donation-button">
      <button
        onClick={() => toggleDonationForm(true)}
        className="spenden-button"
      >
        {'Spenden'}
        <span
          className="heart-icon"
          style={{ backgroundImage: `url(${heartIcon})` }}
        ></span>
      </button>
    </div>
  );
};

export default View;
